import { render } from "./SubSection.vue?vue&type=template&id=9ba658ea&scoped=true"
import script from "./SubSection.vue?vue&type=script&lang=js"
export * from "./SubSection.vue?vue&type=script&lang=js"

import "./SubSection.vue?vue&type=style&index=0&id=9ba658ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba658ea"]])

export default __exports__